<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Run Sheet</strong>
          </div>  


          <b-form  @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row> 

            <b-col sm="4">
               <b-col sm="12">
              <div id='container' >
              <br> 

              <b-form-group label="Select Vehicle"  :label-cols="4" >
                <b-input-group class="mb-3">
                          <b-form-select v-model="customer.vehicle_id" name="vehicle_id" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.vehicle_id') }">
                        <option value="">--Select--</option>
                        <option :value="vehicle.vehicle_id" v-for="vehicle in vehicleitems"  :key="vehicle.vehicle_id" >
                        {{vehicle.vehicle_name}} -  {{vehicle.vehicle_no}} ({{vehicle.vehicleweightcarrying}})
                        </option>
                        </b-form-select>
                        </b-input-group>
                       <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('vehicle_id')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.vehicle_id')" id="statustxt" class="help text-danger">{{ errors.first('form-1.vehicle_id') }}
                        </code>
                        </b-input-group>
                </b-form-group>  
              </div>
            </b-col>
            </b-col>
            <b-col sm="3">

            <div id='container'>
            <br>  
            <b-form-group>   
              <ejs-multiselect id='multiselect' placeholder="Select Shipment status" name="ShipmentStatus" v-model="ShipmentStatus"  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :dataSource='status'     :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.ShipmentStatus') }">
              </ejs-multiselect>
              <span v-show="errors.has('form-1.ShipmentStatus')" class="help text-danger">{{ errors.first('form-1.ShipmentStatus') }}</span>
               </b-form-group>  
            </div>
          </b-col>
            <!-- <b-col sm="4">
            <div>
            <br>     
               <ejs-multiselect id='multiselect' placeholder="Select Order Flow" v-model="orderFlow" name="orderFlow" :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :dataSource='orderflowoptions'     :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" >
              </ejs-multiselect>
              
            </div>
          </b-col> -->
              <b-col sm="3" class="text-right">
               <b-button  type="submit" size="md" variant="primary"> Search</b-button>&nbsp; 

               <b-button  @click="clear" size="md" variant="danger">Clear</b-button>  
            </b-col>  
            <b-col sm="2" >
              
                <div id='container' v-if="totalRows!= '0'" style="display: block">
                  <b-button  id="printbutton" variant="primary" size="md" value="print a div!" @click="printdata('printlist')">Print</b-button>
                </div>
                 
            </b-col>     
          
            </b-row>
              <b-row>
<!--               <b-col sm="4">
                 <b-col sm="12">
                <b-form-group label="From Date:"  :label-cols="4" >
                 <v-date-picker mode='single' v-validate="'required'"  input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              </b-col>
              <b-col sm="4">
                <b-form-group label="To Date:"  :label-cols="4" >
                  <v-date-picker mode='single' v-validate="'required'"  input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col> -->
        

          <!--     <b-col sm="4" class="text-right">
              
                <div id='container' v-if="totalRows!=0" style="display: block">
                  <b-button  id="printbutton" variant="primary" size="md" value="print a div!" @click="printdata('printlist')">Print</b-button>
                </div>
                 
            </b-col>  -->  
              
          </b-row>
<!-- 
            <b-row>
            <b-col md="4" class="my-1">
               <b-col md="12">
                <b-form-group label-cols-sm="4" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              </b-col>
           
              <b-col sm="12" class="text-right">
                <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
             </b-col>
              </b-col>
            </b-row>  -->
          </b-form>  
         
<b-row>

          </b-row>    
          <b-col sm="12">
         <div id="printlist" style="display:none">
    <div class="table-responsive container p-3 runsheet">
        <table class="table table-bordered">
            <tr class="text-center"><th style="text-align:center" colspan="5">Handover Sheet</th></tr>
            <tr>
                <th>Consignor</th>
                <th>Consignee</th>
                <th>Invoice No</th>
                <th colspan="2">120920</th>
            </tr>
            <tr>
                <td rowspan="4"></td>
                <td rowspan="4"></td>
                <tr>
                    <th scope="row">Invoice Date</th>
                    <td colspan="2"></td>
                </tr>
                <tr>
                    <th scope="row">Transporter</th>
                    <td colspan="2"></td>
                </tr>
                <tr>
                    <th scope="row">AWB NO</th>
                    <td colspan="2"></td>
                </tr>
            </tr>
            <tr>
                <td colspan="1"><b>GST NO:</b> 329843279</td>
                <td colspan="4"><b>GST NO:</b> 832479328</td>
            </tr>
            <tr>
                <td colspan="1"><b>FROM: </b>PUNE</td>
                <td colspan="4"><b>TO: </b>INDORE</td>
            </tr>
            <tr>
                <th scope="row" colspan="1">Mode Of Transportation</th>
                <td colspan="4">Surface</td>
            </tr>

            <!-- values -->
            <tr>
                <th scope="col">Actual Weight</th>
                <th scope="col">Volumetric Weight</th>
                <th scope="col">Total No of Boxes</th>
                <th scope="col">Qty</th>
                <th scope="col">Total Value</th>
            </tr>
            <tr>
                <td>280</td>
                <td>135</td>
                <td>31</td>
                <td>1116</td>
                <td>53523</td>
            </tr>
            <tr>
                <th scope="row">Value in Figures</th>
                <td colspan="4">Fifty Three Thousand Five Hundred Twenty Three</td>
            </tr>
            <tr rowspan="3" style="height: 100px;" >
                <td colspan="5" class="align-middle"><b>Handover Date and Time: </b></td>
            </tr>
            <tr>
                <th scope="col" colspan="2">Transporter's Signature/Stamp</th>
                <th scope="col" colspan="3">Warehouse Security's Signature/Stamp</th>
            </tr>
            <tr>
                <td colspan="2" style="height: 200px;"></td>
                <td colspan="3" style="height: 200px;"></td>
            </tr>
            <tr>
                <th scope="col" colspan="2">B2B Supervisor Signature</th>
                <th scope="col" colspan="3">Mobile No. Of Transporter</th>
            </tr>
            <tr>
                <td colspan="2" style="height: 100px;"></td>
                <td colspan="3" style="height: 100px;"></td>
            </tr>
            <tr>
                <td colspan="1" ></td>
                <td colspan="4">
                    <div class="d-flex flex-row">
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">1</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">2</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">3</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">4</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">5</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">6</span>
                        </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="1" ></td>
                <td colspan="4">
                    <div class="d-flex flex-row">
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">1</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">2</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">3</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">4</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">5</span>
                        </span>
                        <span class="box align-items-start">
                            <span class="border"></span><span class="number">6</span>
                        </span>
                    </div>
                </td>
           </tr>
        </table>
    </div>
         
        </div>
         </b-col>
   
        </b-card>
      </b-col>
    </b-row>    
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import { EventBus } from "./event-bus.js";


export default {
  data: function() {
    return {

      agentmaster: [],
      vehicle_id:'',
      deliveryagentname:'',
      shipmenttype:'',
      selected:'',
      options: [],
      showSelectAll : true,
      fields: { text: 'name', value: 'id' },
      allowCustomValue : true,
      value2:"",
      value1:[],
      ShipmentStatus:[],
      orderFlow:[],
      value5:[],
      currDate:this.currdate(new Date()),
      customer: {},
      status:['BookingDone','OFD'],
      orderflowoptions:['forward','reverse'],
      isBusy: false,
      items:[],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      bordered: true,
      filter: null,
      // selectDateFrom: new Date(),
      // selectDateTo:new Date(),
      totalRows: 0,
      currentPage: 1,
     // perPage:  10,
      pageOptions: [5, 10, 15],
      vehicleitems:[],
      // flowfields : { text: 'flow', value: 'Id' },
      // fields1: [
      //     { key: 'awb_no', label: 'AWBno', sortable: true,tdClass: 'tablestyle'},
      //     // { key: 'poid', label: 'POID', sortable: true},
      //     { key: 'customername', label: 'Customer Name', sortable: true,tdClass: 'tablestyle'},
      //     { key: 'area', label: 'Area', sortable: true,tdClass: 'tablestyle' },  
      //     { key: 'address', label: 'Address', sortable: true, tdClass: 'tablestyle' },
      //      { key: 'shipaddress_type', label: 'Address Type', sortable: true, tdClass: 'tablestyle' },
          
      //     { key: 'cod_prepaid', label: 'COD /Prepaid', sortable: true,tdClass: 'tablestyle' },
      //     { key: 'cod_amount', label: 'COD Amount' , sortable: true,tdClass: 'tablestyle'},

      //   ],
    
    };
  },
 
  created: function() {   
     this.displaydeliveryagent();
    //this.getrunlist();

  },
 
  methods: {
 

     displaydeliveryagent: function() {
       // this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const deliveryagentobj = {};
      console.log('deliveryagentobj',deliveryagentobj);
      this.$http
        .post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getVehicleListing`,
          deliveryagentobj
        )
        .then(result => {
          console.log("YYY",result);
          if (result.body.length > 0) {
            // this.isBusy = !this.isBusy
            this.data = result.body;
           
            this.vehicleitems  = result.body;
             
            this.totalRows = result.body.length
          } else {
            // this.isBusy = !this.isBusy
            this.data = result.body;
            this.vehicleitems  = result.body;
            this.totalRows = result.body.length
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    },
     onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering

      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    printdata(printlist){

    var printContents = document.getElementById("printlist").innerHTML;
    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
     
      
      docprint.document.write('<style type="text/css">body{ margin:20px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.printlist{ border-collapse: collapse;margin-bottom: 10px; width:540px;height:540px  } ');
      docprint.document.write('.table {width: 100%;margin-bottom: 1rem;background-color: transparent;}');
      docprint.document.write('.table-bordered {border: 2px solid #c8ced3;}');
      docprint.document.write('table {border-collapse: collapse;}');
      docprint.document.write('.table thead, .table thead tr:hover {background: #ECEFF1 !important;}');
      docprint.document.write('.table thead, .table thead tr {background: #ECEFF1 !important;word-wrap: break-word;}');
       docprint.document.write('tr {display: table-row;vertical-align: inherit;border-color: inherit;}');
        docprint.document.write('td {display: table-cell;}');
        //common heading
        docprint.document.write('td {<label style="text-align:center;margin-left: 350px ;position: fixed; top:0px}">Run Sheet</label>}');
        docprint.document.write('tbody {display: table-row-group;vertical-align: middle;border-color: inherit;}');
        docprint.document.write('.headsection{font-size: 12px;}');
        //common heading end
        docprint.document.write('.table th, .table td {padding: .5rem!important;vertical-align: top!important;}');
      
        docprint.document.write('.table tr th {color: #333 !important;}');
      docprint.document.write('.table th, .table td {padding: .5rem!important;vertical-align: top!important;}');
      docprint.document.write('.table-bordered th, .table-bordered td {border: 1px solid #c8ced3;}');
      docprint.document.write('.table th, .table td {padding: .1rem!important;vertical-align: top!important;}');
      docprint.document.write('.slothead{display: block;}');
      

       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');
       // docprint.document.write('.table.b-table > thead > tr > td[aria-sort], .table.b-table > tfoot > tr > th[aria-sort] {width: 200px;');
      docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        

        docprint.document.write('@page { size: 297mm 210mm; margin-top:40px;margin-bottom:40px; margin-right:20px;margin-left:1px;}</style>');
        

       docprint.document.write('</head><body onLoad="self.print()"><center>');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();

       //self.close();

    },



validateForm(scope) {
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     this.isBusy = true;
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
         // alert("inn");
         document.getElementById("printlist").style.display = "block";
      // var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      // var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
    
    // var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
    // var deliveryagentname_sel = document.getElementById("deliveryagentid");

    //  this.deliveryagentname = deliveryagentname_sel.options[deliveryagentname_sel.selectedIndex].text;



// var vendorarr=[];
//           vendorarr=this.value3;

//           var statusarr=[];
//           statusarr=this.ShipmentStatus;
          
         
//         var orderarr=[];
//           orderarr=this.orderFlow;
            
// var vendorid = vendorarr;
           
           
//            let obj = {
        

//          deliveryagentid:deliveryagentid,
//         //deliveryagentid:deliveryagentidarr,
//         status:statusarr,
//         orderflow:orderarr,
        
//         fromdate:`${fromdate}`, 
//         todate:`${formatdateto}`,
//          hub_id:`${userInfo.pickuplocationmasterid}`,

//       }

//         this.$http
//         .post(
//           `${CONSTANTS.MISREPORT_API_URL}/getrunsheetlist`,obj)
//             .then(result => {
//               // console.log(result.body);
//                 this.isBusy = !this.isBusy;
//                 if(result.body.returnmsg =="Successful"){
//                   // console.log("result.body.returnvalue",result.body.returnvalue);
//                   //this.assigned = result.body.returnvalue;
//                  // this.items  = result.body.returnvalue;
//                   //this.totalRows = result.body.returnvalue.length
                   
//                   this.items =result.body.returnvalue;
//                   //console.log("Heloooooooooooooo",this.items.vendor_name);
//                   //var deliveryagentnamearr=this.items.vendor_name;
//           //deliveryagentnamearr=this.value1;
                 
//                   this.totalRows = result.body.returnvalue.length;
//                 }else {
//                  this.items  = [];
//                  this.totalRows = 0
//                 }
//             }).catch(ex => {
//               console.log('error', ex)
//             })
          }
        })
    },

   //  barcodedata(printlist){


   //    //document.getElementById("printableArea").style.display = "none";

   //   var printContents = document.getElementById("printlist").innerHTML;
   // },

    //  getrunlist(){
    //    var userdata = localStorage.getItem('userData')
    //   var userInfo = JSON.parse(userdata)
    //   document.getElementById("printlist").style.display = "block";
    //   this.isBusy = true;
    //   var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
    //   var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
    
    // var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
    //  var deliveryagentname_sel = document.getElementById("deliveryagentid");

    //  this.deliveryagentname = deliveryagentname_sel.options[deliveryagentname_sel.selectedIndex].text;
     
    //     var vendorarr=[];
    //       vendorarr=this.value3;

    //       var statusarr=[];
    //       statusarr=this.ShipmentStatus;
          
         
    //     var orderarr=[];
    //       orderarr=this.orderFlow;

    //        var vendorid = vendorarr;
           
           
    //        let obj = {
        

    //     deliveryagentid:deliveryagentid,
    //     status:statusarr,
    //     orderflow:orderarr,
        
    //     fromdate:`${fromdate}`, 
    //     todate:`${formatdateto}`,
    //     hub_id:`${userInfo.pickuplocationmasterid}`,


    //   }



    // this.$http
    //     .post(
    //       `${CONSTANTS.MISREPORT_API_URL}/getrunsheetlist`,obj)
    //         .then(result => {
    //           // console.log(result.body);
    //             this.isBusy = !this.isBusy;
    //             if(result.body.returnmsg =="Successful"){
    //               // console.log("result.body.returnvalue",result.body.returnvalue);
    //               //this.assigned = result.body.returnvalue;
    //              // this.items  = result.body.returnvalue;
    //               //this.totalRows = result.body.returnvalue.length
                   
    //               this.items =result.body.returnvalue;
    //               //console.log("Heloooooooooooooo",this.items.vendor_name);
    //               //var deliveryagentnamearr=this.items.vendor_name;
    //       //deliveryagentnamearr=this.value1;
                 
    //               this.totalRows = result.body.returnvalue.length;
    //             }else {
    //              this.items  = [];
    //              this.totalRows = 0
    //             }
    //         }).catch(ex => {
    //           console.log('error', ex)
    //         })
    //       //}
    //   },


     formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

      currdate: function(date){
        var d = new Date(),
      minutes = d.getMinutes().toString().length == 1 ? '0'+d.getMinutes() : d.getMinutes(),
      hours = d.getHours().toString().length == 1 ? '0'+d.getHours() : d.getHours(),
      ampm = d.getHours() >= 12 ? 'pm' : 'am',
      months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  return days[d.getDay()]+' '+months[d.getMonth()]+' '+d.getDate()+' '+d.getFullYear();
  },
     CloseWindow() {
        docprint.close();
    },
      clear: function () {
   //console.log(this.tags.length);
      this.items=[];
      this.deliveryagentid='';
      this.vehicle_id='';
      this.ShipmentStatus='';
      this.orderFlow=[];
      this.totalRows=0;
      this.customer = {};
      document.getElementById("printlist").style.display = "none";
      // this.invalidshipppingid="";
      this.errors.clear('form-1')
    },


  }, //method ends

      

  

};

</script>
<style lang="css">
.table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}

.table-bordered {
    border: 1px solid #c8ced3;
}
table {
    border-collapse: collapse;
}
.table thead, .table thead tr:hover {
    background: #ECEFF1 !important;
}
.table thead, .table thead tr {
    background: #ECEFF1 !important;
    word-wrap: break-word;
}
tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}


  .nameOfTheClass {
   width: 150px;
}
.headsection{
  font-size: 12px;
}
  .runsheet .border{
            display: inline-block;
            width: 30px;
            height: 30px;
            margin: 6px;
        }
      .runsheet  .number{
            display: inline-block;
            width: 30px;
            height: 30px;
            margin: 6px;
        }
      .runsheet  .box{
            display: flex;
            flex-direction: row;
        }
</style>